(function () {
  if (window.__kallesDrawerBridgeV3) return;
  window.__kallesDrawerBridgeV3 = true;

  /* ---------- apri il drawer nativo ---------- */
  function openNativeCartDrawer(){
    try {
      var ev = new CustomEvent('open_cart_drawer', { bubbles: true });
      document.dispatchEvent(ev); window.dispatchEvent(ev);
    } catch(e){}
    var sels = [
      '[data-open-cart]','[data-cart-drawer-toggle]','.js-cart-toggle',
      '.t4s-mini-cart__button','.hdt-cart__toggle'
    ];
    for (var i=0;i<sels.length;i++){ var el=document.querySelector(sels[i]); if(el){ el.click(); return; } }
    var d=document.querySelector('hdt-cart-drawer,#CartDrawer,.hdt-cart-drawer');
    if (d){
      try{ if(typeof d.show==='function'){ d.show(); return; } }catch(e){}
      if ('open' in d) { d.open = true; return; }
      d.setAttribute('open','');
    }
  }

  /* ---------- trova le section id del drawer ---------- */
  function findDrawerSectionHandles(){
    var ids = Array.prototype.map.call(
      document.querySelectorAll('[id^="shopify-section-"]'),
      function(el){ return el.id.replace('shopify-section-',''); }
    );
    // candidati che spesso usa Kalles / OS2
    var cand = ids.filter(function(id){
      return /(cart.*drawer|drawer.*cart|mini.*cart|cart.*sidebar)/i.test(id);
    });
    if (!cand.length) cand = ['cart-drawer','hdt-cart-drawer','mini-cart','cart-mini','cart-sidebar'];
    // unique
    var out=[]; cand.forEach(function(h){ if(out.indexOf(h)===-1) out.push(h); });
    return out;
  }

  /* ---------- ricarica la SEZIONE server-side e sostituisci il DOM ---------- */
  function refreshDrawerSection(){
    var handles = findDrawerSectionHandles();
    var url = window.location.pathname + '?sections=' + handles.join(',');
    return fetch(url, {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(json){
        var updated=false;
        for (var key in json){
          var html = json[key]; if (!html) continue;
          var host = document.getElementById('shopify-section-'+key)
                 || document.querySelector('#shopify-section-'+key+', [data-section-id="'+key+'"]');
          if (host){ host.innerHTML = html; updated=true; }
        }
        return updated;
      })
      .catch(function(){ return false; });
  }

  /* ---------- pipeline: refresh sezione → apri drawer ---------- */
  var _arming = false, _t;
  function openAfterServerRefresh(delay){
    if (delay == null) delay = 0;
    clearTimeout(_t);
    _t = setTimeout(function(){
      if (_arming) return; _arming = true;
      refreshDrawerSection().then(function(){
        openNativeCartDrawer();
      }).finally(function(){ _arming=false; });
    }, delay);
  }

  /* ---------- riconosci *qualsiasi* mutazione del carrello ---------- */
  function isCartMut(url, method){
    url = String(url||''); method = String(method||'GET').toUpperCase();
    if (method==='POST' && /\/cart\/(add|change|update)(\.js)?(\?|$)/i.test(url)) return true;
    if (method==='POST' && /\/cart(\?|$)/i.test(url) && !/\/cart\.js(\?|$)/i.test(url)) return true;
    if (/\/cart\/change\.js\?/i.test(url)) return true; // alcune app usano GET
    return false;
  }

  // 1) Eventi comuni post-ATC (ignoriamo quelli generati da noi)
  function onEvt(e){ if (e && e.detail && e.detail.fromBridge) return; openAfterServerRefresh(20); }
  ['ajaxProduct:added','product:added','added_to_cart','cart:refresh','cart:updated','cart:change','hdt:cart:changed','hdt:cart:updated']
    .forEach(function(evt){ document.addEventListener(evt,onEvt); window.addEventListener(evt,onEvt); });

  // 2) fetch
  if (window.fetch){
    var _fetch = window.fetch;
    window.fetch = function(input, init){
      var url = (typeof input==='string') ? input : (input && input.url) || '';
      var method = init && (init.method || init.type) || 'GET';
      var mut = isCartMut(url, method);
      return _fetch.apply(this, arguments).then(function(res){
        try{ if (mut && res && (res.ok || res.status===200)) openAfterServerRefresh(40); }catch(e){}
        return res;
      });
    };
  }

  // 3) XHR
  if (window.XMLHttpRequest){
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method,url){ this.__isCartMut=isCartMut(url,method); return _open.apply(this,arguments); };
    XMLHttpRequest.prototype.send = function(){ this.addEventListener('load',function(){ if(this.__isCartMut && this.status>=200 && this.status<400) openAfterServerRefresh(40); }); return _send.apply(this,arguments); };
  }

  // 4) jQuery $.ajax
  function patchJQ(){
    if (!window.jQuery || !window.jQuery.ajax || window.__kallesPatchedJQ) return;
    window.__kallesPatchedJQ = true;
    var $=window.jQuery, _ajax=$.ajax;
    $.ajax = function(opt){
      var url='', type='GET';
      if (typeof opt==='string') url=opt; else if (opt){ url=opt.url||''; type=opt.type||opt.method||'GET'; }
      var jq = _ajax.apply(this, arguments);
      if (isCartMut(url,type) && jq && jq.done) jq.done(function(){ openAfterServerRefresh(40); });
      return jq;
    };
  }
  var jqIv=setInterval(function(){ try{ patchJQ(); if(window.__kallesPatchedJQ) clearInterval(jqIv); }catch(e){} },200);

  // 5) Fallback: submit /cart/add e click sui classici ATC
  var ATC_SEL=[
    '[data-add-to-cart]','[data-add-atc]','[data-hdt-atc]',
    '.hdt-btn-addtocart','.hdt-pr__btn-atc','.hdt-add-to-cart','hdt-atc-button',
    'button[name="add"]','form[action*="/cart/add"] [type="submit"]'
  ].join(',');
  document.addEventListener('submit',function(e){ var a=(e.target&&e.target.getAttribute('action'))||''; if(/\/cart\/add/i.test(a)) setTimeout(function(){ openAfterServerRefresh(500); },0); },true);
  document.addEventListener('click',function(e){ var btn=e.target.closest?e.target.closest(ATC_SEL):null; if(btn) setTimeout(function(){ openAfterServerRefresh(700); },0); },true);

  // test manuale
  window.__kallesDrawerTest = function(){ openAfterServerRefresh(0); };
})();